import script from "./UserPayments.vue?vue&type=script&setup=true&lang=js"
export * from "./UserPayments.vue?vue&type=script&setup=true&lang=js"

import "./UserPayments.vue?vue&type=style&index=0&id=e4c1b59a&lang=css"

const __exports__ = script;

export default __exports__